import React, { Component } from 'react'
import { connect } from 'react-redux';
import _ from 'lodash'

class RoleCheck extends Component {

    isAllowed() {
        if(_.isArray(this.props.allow)) {
            return _.some(this.props.allow, x => x === this.props.role);
        } else if(typeof(this.props.allow) === "string") {
            return (this.props.allow === this.props.role);
        } else if(typeof(this.props.allow) === "function") {
            return this.props.allow(this.props.role)
        } else if(typeof(this.props.allow) === "boolean") {
            return this.props.allow;
        } else {
            return false;
        }
    }

    render () {
        if(this.isAllowed()) {
            return this.props.children;
        } else {
            if(this.props.alternative) {
                return this.props.alternative;
            } else {
                return null;
            }
        }
    }
}

const mapStateToProps = (state) => {
    return {
        role: (state.user.role || {}).role1
    };
}

export default connect(mapStateToProps)(RoleCheck)